import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteWeitra() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-weitra-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-weitra-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="weitra" />
      </div>
    </div>
  );
}

export default BodenfeuchteWeitra;
